import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();

export interface ContactMessagePayload {
  userId?: number | null;
  fullName: string;
  email: string;
  subject: string;
  content: string;
}

export const submitContactMessage = createAsyncThunk(
  "contactMessages/submitContactMessage",
  async (payload: ContactMessagePayload, { rejectWithValue }) => {
    try {
      const response = await api.create("/api/contact-messages", payload);
      return response.data; // Returns { code, message, data }
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to submit contact message. Please try again."
      );
    }
  }
);
